import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from 'src/app/shared/component/confirmation-popup/confirmation-popup.component';
import { Context } from 'src/app/shared/models/context';
import { Absence, Employee, Message, PrivilegeType } from 'src/app/shared/models/domain';
import { AppearanceService } from 'src/app/shared/services/appearance.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { AbsenceCrudComponent } from '../absence-crud/absence-crud.component';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-absence-list',
  templateUrl: './absence-list.component.html',
  styleUrls: ['./absence-list.component.scss'],
})
export class AbsenceListComponent implements OnInit {
  public absences: Absence[] = [];
  public context: Context;
  public employees: Employee[] = [];
  public fromDate: string;
  public toDate: string;
  public isLoading: boolean = true;
  public privilege: PrivilegeType;

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    private commonService: CommonService,
    private apperanceService: AppearanceService,
    private datePipe: DatePipe,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.dataService.privilege().subscribe(privilege => { this.privilege = this.commonService.getPrivileges(privilege) });
    this.fromDate = this.datePipe.transform(this.commonService.adjustDateByDays(-30), 'yyyy-MM-dd');
    this.toDate = this.datePipe.transform(this.commonService.adjustDateByDays(30), 'yyyy-MM-dd');
    this.context = this.authService.getContextData();
    if (this.context && this.context?.companyId) {
      this.getAbsence();
    }
  }

  private getAbsence(clear: boolean = true) {
    if (this.context?.employeeId) {
      if (clear) {
        this.isLoading = true;
        this.absences = [];
      }
      if (!this.fromDate || !this.toDate) {
        this.commonService.setToastr(500, "Both \"From Date\" and \"To Date\" are required to proceed.")
        return;
      }
      const fromDate = this.datePipe.transform(this.fromDate, 'dd-MM-yyyy');
      const toDate = this.datePipe.transform(this.toDate, 'dd-MM-yyyy');
      this.apperanceService.getAbsences(this.context?.employeeId, fromDate, toDate,'APPLIED').subscribe({
        next: (absences: Absence[]) => {
          this.absences = absences.sort((a, b) => a.id - b.id);
          this.isLoading = false;
        },
        error: (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.commonService.setToastr(500, error?.error?.name || error.error);
        }
      });
    } else {
      this.isLoading = false;
    }
  }

  public deleteAbsence(absence: Absence, index: number) {
    if (!this.privilege.canDelete) return;
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.title = "Absense deletion";
    modalRef.componentInstance.prefixMessage = "Are you sure you want to delete";
    modalRef.componentInstance.message = "Absense";
    modalRef.componentInstance.label = 'absense';
    modalRef.result.then((isConfirmed: boolean) => {
      if (isConfirmed) {
        absence.isDeleteInProgress = true;
        absence.status = "CANCELLED";
        this.apperanceService.updateAbsence(absence.id,absence).subscribe({
          next: (response: Absence) => {
            if (response) {
              this.commonService.setToastr(200,'The absence has been successfully cancelled!');
              this.absences.splice(index, 1);
              this.getAbsence(false);
              absence.isDeleteInProgress = false;
            } else {
              this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
              absence.isDeleteInProgress = false;
            }
          },
          error: (error: HttpErrorResponse) => {
            this.commonService.setToastr(500, error?.error?.name || error.error);
            absence.isDeleteInProgress = false;
          },
        });
      }
    });
  }

  public upsertAbsence(absence?: Absence) {
    if (!this.privilege.canEdit) return;
    const modalRef = this.modalService.open(AbsenceCrudComponent, { size: 'lg', backdrop: 'static' });
    modalRef.componentInstance.absence = absence;
    modalRef.componentInstance.context = this.context;
    modalRef.result.then((response: Absence) => {
      if (response.id) {
        this.getAbsence(false);
      }
    });
  }

  public onAbsenceChange() {
    this.getAbsence(false);
  }
}